import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { sortBy } from 'lodash'

import CustomerRow from './CustomerRow'
import usePrevious from '../../hooks/usePrevious'

import { searchData } from '../../utils/searchData'

const SuitesCustomers = ({
  currentVenueUuid,
  customers,
  history,
  loadCustomers,
  loadAllCustomerOrderingPreferences,
  loadRevenueCenters,
  onSelectCustomer,
  searchCustomerValue,
}) => {
  const searchedData = sortBy(useMemo(() => searchData(searchCustomerValue, customers), [customers, searchCustomerValue]), 'name')
  const previousCurrentVenueUuid = usePrevious(currentVenueUuid)

  useEffect(() => {
    if (currentVenueUuid === previousCurrentVenueUuid) return

    loadCustomers(currentVenueUuid)
    // eslint-disable-next-line
  }, [currentVenueUuid, loadCustomers])

  useEffect(() => {
    if (currentVenueUuid === previousCurrentVenueUuid) return

    loadAllCustomerOrderingPreferences(currentVenueUuid)
    // eslint-disable-next-line
  }, [loadAllCustomerOrderingPreferences, currentVenueUuid])

  useEffect(() => {
    if (currentVenueUuid === previousCurrentVenueUuid) return

    loadRevenueCenters(currentVenueUuid)
    // eslint-disable-next-line
  }, [loadRevenueCenters, currentVenueUuid])

  return (
    <div className='customers'>
      <div className="header">
        <ul className="header__menu">
          <li>Name</li>
        </ul>
      </div>
      {searchedData.map((customer, key) => (
        <CustomerRow
          key={key}
          customer={customer}
          history={history}
          onSelectCustomer={onSelectCustomer}
        />
      ))}
    </div>
  )
}

SuitesCustomers.defaultProps = {
  customers: [],
  loadCustomers: () => {},
  loadAllCustomerOrderingPreferences: () => {},
  onSelectCustomer: () => {},
}

SuitesCustomers.propTypes = {
  customers: PropTypes.arrayOf(PropTypes.object),
  loadCustomers: PropTypes.func,
  loadAllCustomerOrderingPreferences: PropTypes.func,
  onSelectCustomer: PropTypes.func,
}

export default SuitesCustomers
